const basePersonQuery = (personId: string, type: string) => `query { person(id: "${personId}"){ ${type} }}`;

export const getPlanClaimHeadersByPersonQuery = (personId: string) => basePersonQuery(personId, 'planClaimHeader');
export const getMedicationListByPersonQuery = (personId: string) => basePersonQuery(personId, 'medicationlist');
export const getAllergyByPersonQuery = (personId: string) => basePersonQuery(personId, 'allergy');
